<template>
<div :style='burgerWrapperStyles'
     :class='{ "b-burger-wrapper--active": isActive }'
     class='b-burger-wrapper'
     @click.stop='handleToggleStatus'>
    <div v-for='i in 3'
         :key='i'
         :style='burgerInnerStyles'></div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class BurgerIcon extends Vue {
    @Prop({ type: Number, required: true }) readonly size!: number;
    @Prop({ type: Boolean, required: true }) readonly isActive!: number;
    @Prop({ type: String, default: '#333' }) readonly color!: string;

    get burgerWrapperStyles() {
        return {
            width: `${this.size}px`,
            height: `${Math.ceil(this.size * 0.6)}px`,
        };
    }
    get burgerInnerStyles() {
        return {
            background: this.color,
        };
    }

    @Emit('toggle')
    handleToggleStatus() {}
};
</script>

<style lang='sass'>
.b-burger-wrapper
    display: flex
    flex-direction: column
    flex-wrap: wrap
    justify-content: space-between
    cursor: pointer

    &.b-burger-wrapper--active
        & > div
            &:first-of-type
                transform: rotate(-45deg) translate(0px, -2px)
                width: 100%

            &:nth-of-type(2)
                opacity: 0

            &:last-of-type
                transform: rotate(45deg) translate(1px, 3px)
                width: 100%

    & > div
        width: 100%
        height: 3px
        transition: transform .3s, opacity .3s, width .3s
        border-radius: 5px

        &:first-of-type
            transform-origin: 100% 50%

        &:last-of-type
            transform-origin: 100% 50%
</style>
